/**
 * LaunchDarkly configuration for how long inbound H2D Cancel stays a spinner.
 *
 * Flag key: {@link INBOUND_H2D_CANCEL_DELAY_LD_FLAG_KEY} (`inboundH2DCancelDelay`).
 * Invalid values fall back to {@link DEFAULT_INBOUND_H2D_CANCEL_DELAY_MS}.
 */
export const INBOUND_H2D_CANCEL_DELAY_LD_FLAG_KEY = 'inboundH2DCancelDelay';

// Keep Cancel as a spinner on initial inbound H2D connect so agents do not
// cancel immediately when the call is received.
export const DEFAULT_INBOUND_H2D_CANCEL_DELAY_MS = 15_000;

export interface InboundHearingCancelDelayConfig {
  delayMs: number;
}

export type InboundHearingCancelDelayFlagValue =
  Partial<InboundHearingCancelDelayConfig> | undefined | null;

/** Reads the raw JSON value from LaunchDarkly flags. */
export const getInboundHearingCancelDelayFlag = (
  flags: Record<string, unknown>
): InboundHearingCancelDelayFlagValue => {
  const rawValue = flags[INBOUND_H2D_CANCEL_DELAY_LD_FLAG_KEY];
  return rawValue && typeof rawValue === 'object'
    ? (rawValue as InboundHearingCancelDelayFlagValue)
    : undefined;
};

export const resolveInboundHearingCancelDelayMs = (
  flagValue: InboundHearingCancelDelayFlagValue
): number => {
  const delayMs = flagValue?.delayMs;

  return typeof delayMs === 'number' && Number.isInteger(delayMs) && delayMs > 0
    ? delayMs
    : DEFAULT_INBOUND_H2D_CANCEL_DELAY_MS;
};
